/* Progressive enhancement: the complete article remains readable without JS. */
(() => {
  function enhance(root = document) {
    root.querySelectorAll('[data-aza-article]').forEach(content => {
      if (content.dataset.azaEnhanced) return;
      content.dataset.azaEnhanced = 'true';
      const headings = [...content.querySelectorAll('h2,h3')].filter(h => h.textContent.trim());
      if (headings.length < 3) return;
      const nav = document.createElement('nav');
      nav.className = 'aza-article-toc';
      nav.setAttribute('aria-label', content.dataset.tocLabel || 'In this article');
      const title = document.createElement('p');
      title.textContent = content.dataset.tocLabel || 'In this article';
      const list = document.createElement('ul');
      headings.forEach((h, i) => {
        if (!h.id) {
          let id = 'article-topic-' + i;
          while (document.getElementById(id)) id += '-x';
          h.id = id;
        }
        const li = document.createElement('li'), a = document.createElement('a');
        a.href = '#' + h.id; a.textContent = h.textContent.trim();
        li.append(a); list.append(li);
      });
      nav.append(title, list); content.before(nav);
    });
  }
  enhance();
  document.addEventListener('shopify:section:load', e => enhance(e.target));
  document.addEventListener('aza:article:open', () => enhance());
})();
